import { render, staticRenderFns } from "./MyChangeKennelOwnerRequestList.vue?vue&type=template&id=7d372440"
import script from "./MyChangeKennelOwnerRequestList.vue?vue&type=script&lang=ts"
export * from "./MyChangeKennelOwnerRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports